import {SAILS_APP_NAME} from '../../constant';

/**
 * GLASFASER_REGISTRATION_API_URL
 */
export const GLASFASER_REGISTRATION_API_URL = '/api/vfd2dyn/json/glasfaser/prereg.php';

/**
 * GLASFASER_LANDUSE_REGISTRATION_API_URL
 */
export const GLASFASER_LANDUSE_REGISTRATION_API_URL = '/api/vfd2dyn/json/glasfaser/preregcontract.php';

/**
 * Export SHOW_QUESTION LOCATION
 */
export const INIT_REGISTRATION_FORM = `${SAILS_APP_NAME}/INIT_REGISTRATION_FORM`;

/**
 * Export READ_SESSION_STORAGE
 */
 export const READ_SESSION_STORAGE = `${SAILS_APP_NAME}/READ_SESSION_STORAGE`;

/**
 * Export SHOW_QUESTION LOCATION
 */
export const SAVE_REGISTRATION_DATA = `${SAILS_APP_NAME}/SAVE_REGISTRATION_DATA`;

/**
 * Export SHOW_QUESTION LOCATION
 */
export const SEND_REGISTRATION_DATA = `${SAILS_APP_NAME}/SEND_REGISTRATION_DATA`;

/**
 * Export GET_REGISTRATION_SUCCESS
 */
export const GET_REGISTRATION_SUCCESS = `${SAILS_APP_NAME}/GET_REGISTRATION_SUCCESS`;

/**
 * Export HANDLE_VALID_API_RESPONSE
 */
export const HANDLE_VALID_API_RESPONSE = `${SAILS_APP_NAME}/HANDLE_VALID_API_RESPONSE`;

/**
 * Export HANDLE_INVALID_API_RESPONSE
 */
export const HANDLE_INVALID_API_RESPONSE = `${SAILS_APP_NAME}/HANDLE_INVALID_API_RESPONSE`;

/**
 * Export TRACK_REGISTRATION_CHECK
 */
 export const TRACK_REGISTRATION_CHECK = `${SAILS_APP_NAME}/TRACK_REGISTRATION_CHECK`;

/**
 * Export TRACK_INIT
 */
export const TRACK_INIT = `${SAILS_APP_NAME}/TRACK_INIT`;

/**
 * Type of the form that needs to be mounted
 */
export enum FormType {
    REGISTRATION = 'registration',
    LANDUSE = 'landuse',
}

/**
 * If the additionalPageOptions.formType property is not filled,
 * this is the default form to be used
 */
export const DEFAULT_FORM_OPTION: string = FormType.REGISTRATION;

/**
 * Id of the represented by container
 */
export const REPRESENTED_BY_CONTAINER_ID: string = 'form-represented-by';

/**
 * HTML id of the confirmation name
 */
export const CONFIRMATION_NAME_ID: string = 'confirmation-name-span';

/**
 * HTML id of number of business units form input
 */
export const NUMBER_OF_BUSINESS_UNIT_ID = 'input-number-of-business-unit';

/**
 * HTML id of number of residence form input
 */
export const NUMBER_OF_RESIDENCE_ID = 'input-number-of-residence';

/**
 * HTML id of represented by checkbox
 */
export const REPRESENTED_BY_CHECKBOX_ID = 'input-represented-by';

/**
 * VFP address session storage key
 */
 export const ADDRESS_SESSION_STORAGE_KEY: string = 'glasfaser_vfp_result';

/**
 * Use this fix value at the api call instead of an input
 * Jira ticket: https://jira.wf-de.vodafone.com/projects/ADTDXC6/issues/ADTDXC6-531
 */
export const INPUT_LAND_FIXED_VALUE = 'Deutschland';
